import { jsxs, jsx } from "react/jsx-runtime";
import { STEP_CONFIGS } from "./constants.js";
const HEADER_BACKGROUND_EXTRA_PX = 8;
function StepHeader({ stepIndex, isEven, bleedPx = 0 }) {
  const config = STEP_CONFIGS[stepIndex];
  if (!config) return null;
  const backgroundExtraPx = stepIndex >= 1 && stepIndex <= 2 ? HEADER_BACKGROUND_EXTRA_PX : 0;
  const curveBottom = -bleedPx - backgroundExtraPx - 1;
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: "relative w-full",
      style: {
        height: config.barHeight + config.curveHeight,
        overflow: "visible"
      },
      children: [
        /* @__PURE__ */ jsx(
          "div",
          {
            "aria-hidden": "true",
            style: {
              position: "absolute",
              inset: 0,
              height: config.barHeight + config.curveHeight + bleedPx + backgroundExtraPx,
              background: config.barColor
            }
          }
        ),
        /* @__PURE__ */ jsx(
          "div",
          {
            style: {
              position: "absolute",
              bottom: curveBottom,
              left: isEven ? 0 : bleedPx,
              right: isEven ? bleedPx : 0,
              height: config.curveHeight + 1,
              background: "#ffffff",
              ...isEven ? { borderTopRightRadius: config.curveHeight } : { borderTopLeftRadius: config.curveHeight }
            }
          }
        )
      ]
    }
  );
}
export {
  StepHeader
};
//# sourceMappingURL=StepHeader.js.map
